// extracted by mini-css-extract-plugin
export default {"collectionTitle":"_23w4sd","collectionName":"_1grjsau","collectionTeaser":"_1ta4ykr"};